'use client';

import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { fireOnce } from '@/lib/fireOnce';
import analytics from '@/services/analytics';
type HeroBlockSearchFormProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function HeroBlockSearchFormContainer(t0) {
  const $ = _c(14);
  let children;
  let className;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onClick;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    onClick = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("search-form", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== onClick) {
    t2 = e => {
      const windowLocation = window.location.toString();
      fireOnce(`search-booking-engagement-${windowLocation}`, () => {
        analytics.track("search_booking_engagement", {
          location: windowLocation
        });
      }, "session");
      onClick?.(e);
    };
    $[7] = onClick;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== props || $[11] !== t1 || $[12] !== t2) {
    t3 = <div className={t1} onClick={t2} {...props}>{children}</div>;
    $[9] = children;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}